(function() {
  function initVariantPickerFetch() {
    document.querySelectorAll('[id^="product-form-new-"]').forEach(function(productFormContainer) {
      const form = productFormContainer.querySelector('form');
      if (!form || form.dataset.variantPickerFetchInitialized === 'true') return;
      
      form.dataset.variantPickerFetchInitialized = 'true';
      
      const productHandle = productFormContainer.getAttribute('handle');
      const formId = form.getAttribute('id');
      if (!productHandle || !formId) return;
      
      form.addEventListener('change', function(e) {
        if (e.target.type !== 'radio' || !e.target.hasAttribute('data-option-position')) return;
        if (parseInt(e.target.getAttribute('data-option-position')) !== 1) return;
        
        const currentVariantPicker = form.querySelector('variant-picker-quick-buy');
        if (!currentVariantPicker) return;
        
        const selectedOptionValues = Array.from(currentVariantPicker.querySelectorAll('input[data-option-position]:checked'))
          .sort((a, b) => parseInt(a.getAttribute('data-option-position')) - parseInt(b.getAttribute('data-option-position')))
          .map(input => input.value);
        
        const fetchUrl = `${window.Shopify?.routes?.root || '/'}products/${productHandle}?option_values=${selectedOptionValues.join(',')}`;
        
        fetch(fetchUrl)
          .then(response => response.ok ? response.text() : null)
          .then(function(html) {
            if (!html) return;
            
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const fetchedVariantPicker = doc.querySelector('variant-picker');
            if (!fetchedVariantPicker) return;
            
            const newVariantPicker = fetchedVariantPicker.cloneNode(true);
            const newElement = document.createElement('variant-picker-quick-buy');
            
            Array.from(newVariantPicker.attributes).forEach(attr => newElement.setAttribute(attr.name, attr.value));
            while (newVariantPicker.firstChild) newElement.appendChild(newVariantPicker.firstChild);
            
            newElement.querySelectorAll('input[data-option-position]').forEach(function(input) {
              const optionPos = input.getAttribute('data-option-position');
              if (!optionPos) return;
              
              input.setAttribute('name', formId + '-option' + optionPos);
              input.removeAttribute('form');
              
              const originalId = input.id;
              if (originalId) {
                const lastDashIndex = originalId.lastIndexOf('-');
                if (lastDashIndex > 0) {
                  const valueId = originalId.substring(lastDashIndex + 1);
                  const newId = `option-value-${optionPos}-${formId}-option${optionPos}-${valueId}`;
                  input.id = newId;
                  
                  const label = newElement.querySelector(`label[for="${originalId}"]`);
                  if (label) label.setAttribute('for', newId);
                }
              }
            });
            
            const optionsContainer = form.querySelector('.product-card__options-container');
            const oldVariantPicker = optionsContainer?.querySelector('variant-picker-quick-buy');
            if (oldVariantPicker) {
              oldVariantPicker.replaceWith(newElement);
              setTimeout(initSizeLabelAutoSubmit, 50);
            }
          })
          .catch(console.error);
      });
    });
  }

  function initSizeLabelAutoSubmit() {
    document.querySelectorAll('label.block-swatch.talla, label.block-swatch.tallas, label.block-swatch.size, label.block-swatch.sizes').forEach(function(label) {
      if (label.dataset.sizeLabelListener === 'true') return;
      label.dataset.sizeLabelListener = 'true';
      
      label.addEventListener('click', function(e) {
        const labelFor = label.getAttribute('for');
        if (!labelFor) return;
        
        const input = document.getElementById(labelFor);
        if (!input || input.disabled) return;
        
        const form = input.closest('form');
        const variantIdInput = form?.querySelector('input[name="id"]');
        if (!form || !variantIdInput) return;
        
        const productForm = form.closest('[id^="product-form-new-"]');
        const variantScript = productForm?.querySelector('script[data-product-id-json]');
        if (!productForm || !variantScript) return;
        
        let variants;
        try {
          variants = JSON.parse(variantScript.textContent);
        } catch (e) {
          return;
        }
        
        input.checked = true;
        
        const variantPicker = form.querySelector('variant-picker-quick-buy');
        if (!variantPicker) return;
        
        const optionTexts = Array.from(variantPicker.querySelectorAll('input[data-option-position]:checked'))
          .sort((a, b) => parseInt(a.getAttribute('data-option-position')) - parseInt(b.getAttribute('data-option-position')))
          .map(function(inputEl) {
            const inputLabel = form.querySelector(`label[for="${inputEl.id}"]`);
            if (!inputLabel) return '';
            const srOnly = inputLabel.querySelector('.sr-only');
            const text = srOnly ? srOnly.textContent.trim() : inputLabel.textContent.trim();
            return text.replace(/\s+/g, ' ').trim();
          })
          .filter(Boolean);
        
        const variantKey = optionTexts.join(' / ');
        const matchingVariant = variants.find(function(v) {
          return v.title && v.title.trim() === variantKey && (v.available === "true" || v.available === true);
        });
        
        if (matchingVariant) {
          variantIdInput.value = matchingVariant.id;
          variantIdInput.disabled = false;
          form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
        }
      });
    });
  }

  function init() {
    setTimeout(initVariantPickerFetch, 200);
    setTimeout(initSizeLabelAutoSubmit, 200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  const observer = new MutationObserver(function(mutations) {
    const shouldReinit = mutations.some(function(mutation) {
      return Array.from(mutation.addedNodes).some(function(node) {
        return node.nodeType === 1 && (node.matches?.('[id^="product-form-new-"]') || node.querySelector?.('[id^="product-form-new-"]'));
      });
    });
    
    if (shouldReinit) {
      setTimeout(initVariantPickerFetch, 100);
      setTimeout(initSizeLabelAutoSubmit, 100);
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });


  // mobile quick buy
  function initMobileVariantPickerFetch() {
    document.querySelectorAll('[id^="mobile-product-form-new-"]').forEach(function(productFormContainer) {
      const form = productFormContainer.querySelector('form');
      if (!form || form.dataset.mobileVariantPickerFetchInitialized === 'true') return;
      
      form.dataset.mobileVariantPickerFetchInitialized = 'true';
      
      const productHandle = productFormContainer.getAttribute('handle');
      const formId = form.getAttribute('id');
      if (!productHandle || !formId) return;
      
      form.addEventListener('change', function(e) {
        if (e.target.type !== 'radio' || !e.target.hasAttribute('data-option-position')) return;
        if (parseInt(e.target.getAttribute('data-option-position')) !== 1) return;
        
        const currentVariantPicker = form.querySelector('variant-picker-quick-buy');
        if (!currentVariantPicker) return;
        
        const selectedOptionValues = Array.from(currentVariantPicker.querySelectorAll('input[data-option-position]:checked'))
          .sort((a, b) => parseInt(a.getAttribute('data-option-position')) - parseInt(b.getAttribute('data-option-position')))
          .map(input => input.value);
        
        const fetchUrl = `${window.Shopify?.routes?.root || '/'}products/${productHandle}?option_values=${selectedOptionValues.join(',')}`;
        
        fetch(fetchUrl)
          .then(response => response.ok ? response.text() : null)
          .then(function(html) {
            if (!html) return;
            
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const fetchedVariantPicker = doc.querySelector('variant-picker');
            if (!fetchedVariantPicker) return;
            
            const newVariantPicker = fetchedVariantPicker.cloneNode(true);
            const newElement = document.createElement('variant-picker-quick-buy');
            
            Array.from(newVariantPicker.attributes).forEach(attr => newElement.setAttribute(attr.name, attr.value));
            while (newVariantPicker.firstChild) newElement.appendChild(newVariantPicker.firstChild);
            
            newElement.querySelectorAll('input[data-option-position]').forEach(function(input) {
              const optionPos = input.getAttribute('data-option-position');
              if (!optionPos) return;
              
              input.setAttribute('name', formId + '-option' + optionPos);
              input.removeAttribute('form');
              
              const originalId = input.id;
              if (originalId) {
                const lastDashIndex = originalId.lastIndexOf('-');
                if (lastDashIndex > 0) {
                  const valueId = originalId.substring(lastDashIndex + 1);
                  const newId = `option-value-${optionPos}-${formId}-option${optionPos}-${valueId}`;
                  input.id = newId;
                  
                  const label = newElement.querySelector(`label[for="${originalId}"]`);
                  if (label) label.setAttribute('for', newId);
                }
              }
            });
            
            const optionsContainer = form.querySelector('.product-card__options-container');
            const oldVariantPicker = optionsContainer?.querySelector('variant-picker-quick-buy');
            if (oldVariantPicker) {
              oldVariantPicker.replaceWith(newElement);
              setTimeout(initMobileSizeLabelAutoSubmit, 50);
            }
          })
          .catch(console.error);
      });
    });
  }

  function initMobileSizeLabelAutoSubmit() {
    document.querySelectorAll('[id^="mobile-product-form-new-"]').forEach(function(productFormContainer) {
      const form = productFormContainer.querySelector('form');
      if (!form) return;
      
      const sizeLabels = form.querySelectorAll('label.block-swatch.talla, label.block-swatch.tallas, label.block-swatch.size, label.block-swatch.sizes');
      
      sizeLabels.forEach(function(label) {
        if (label.dataset.mobileSizeLabelListener === 'true') return;
        label.dataset.mobileSizeLabelListener = 'true';
        
        label.addEventListener('click', function(e) {
          const labelFor = label.getAttribute('for');
          if (!labelFor) return;
          
          const input = document.getElementById(labelFor);
          if (!input || input.disabled) return;
          
          const form = input.closest('form');
          const variantIdInput = form?.querySelector('input[name="id"]');
          if (!form || !variantIdInput) return;
          
          const productForm = form.closest('[id^="mobile-product-form-new-"]');
          const variantScript = productForm?.querySelector('script[data-product-id-json]');
          if (!productForm || !variantScript) return;
          
          let variants;
          try {
            variants = JSON.parse(variantScript.textContent);
          } catch (e) {
            return;
          }
          
          input.checked = true;
          
          const variantPicker = form.querySelector('variant-picker-quick-buy');
          if (!variantPicker) return;
          
          const optionTexts = Array.from(variantPicker.querySelectorAll('input[data-option-position]:checked'))
            .sort((a, b) => parseInt(a.getAttribute('data-option-position')) - parseInt(b.getAttribute('data-option-position')))
            .map(function(inputEl) {
              const inputLabel = form.querySelector(`label[for="${inputEl.id}"]`);
              if (!inputLabel) return '';
              const srOnly = inputLabel.querySelector('.sr-only');
              const text = srOnly ? srOnly.textContent.trim() : inputLabel.textContent.trim();
              return text.replace(/\s+/g, ' ').trim();
            })
            .filter(Boolean);
          
          const variantKey = optionTexts.join(' / ');
          const matchingVariant = variants.find(function(v) {
            return v.title && v.title.trim() === variantKey && (v.available === "true" || v.available === true);
          });
          
          if (matchingVariant) {
            variantIdInput.value = matchingVariant.id;
            variantIdInput.disabled = false;
            form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
            
            const modal = form.closest('x-modal');
            if (modal) {
              const closeModal = function() {
                const closeButton = modal.querySelector('dialog-close-button');
                if (closeButton) {
                  closeButton.click();
                } else if (typeof modal.hide === 'function') {
                  modal.hide();
                } else if (modal.hasAttribute('open')) {
                  modal.removeAttribute('open');
                }
              };
              
              const cartDrawer = document.querySelector('cart-drawer');
              if (cartDrawer) {
                cartDrawer.addEventListener('dialog:after-show', closeModal, { once: true });
              } else {
                document.addEventListener('cart:change', function() {
                  setTimeout(closeModal, 100);
                }, { once: true });
              }
            }
          }
        });
      });
    });
  }

  function initMobile() {
    setTimeout(initMobileVariantPickerFetch, 200);
    setTimeout(initMobileSizeLabelAutoSubmit, 200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobile);
  } else {
    initMobile();
  }
  
  const mobileObserver = new MutationObserver(function(mutations) {
    const shouldReinit = mutations.some(function(mutation) {
      return Array.from(mutation.addedNodes).some(function(node) {
        return node.nodeType === 1 && (node.matches?.('[id^="mobile-product-form-new-"]') || node.querySelector?.('[id^="mobile-product-form-new-"]'));
      });
    });
    
    if (shouldReinit) {
      setTimeout(initMobileVariantPickerFetch, 100);
      setTimeout(initMobileSizeLabelAutoSubmit, 100);
    }
  });

  mobileObserver.observe(document.body, { childList: true, subtree: true });

  // Product Card Carousel Initialization
  function initProductCardCarousel(carouselElement) {
    const carouselId = carouselElement.getAttribute('data-product-card-carousel-id');
    if (!carouselId || carouselElement.dataset.carouselInitialized === 'true') return;
    
    carouselElement.dataset.carouselInitialized = 'true';
    
    const carouselWrapper = carouselElement.closest('[data-carousel-id="' + carouselId + '"]');
    if (!carouselWrapper) return;
    
    const slides = carouselWrapper.querySelectorAll('.product-card__carousel-slide');
    const prevButton = carouselWrapper.querySelector('[data-carousel-prev]');
    const nextButton = carouselWrapper.querySelector('[data-carousel-next]');
    
    if (slides.length === 0) return;
    
    let currentSlide = 0;
    const totalSlides = slides.length;
    
    const showSlide = function(index) {
      if (index < 0) {
        currentSlide = totalSlides - 1;
      } else if (index >= totalSlides) {
        currentSlide = 0;
      } else {
        currentSlide = index;
      }
      
      const translateX = -currentSlide * 100;
      carouselElement.style.transform = `translateX(${translateX}%)`;
      carouselElement.style.transition = 'transform 0.4s ease-in-out';
      
      slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === currentSlide);
      });
    };
    
    window['carousel_' + carouselId] = {
      showSlide: showSlide,
      getCurrentSlide: function() { return currentSlide; },
      setCurrentSlide: function(index) { currentSlide = index; }
    };
    
    showSlide(0);
    
    // Initialize desktop hover behavior
    initDesktopHoverBehavior(carouselWrapper, carouselId, totalSlides);
    
    if (prevButton) {
      prevButton.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        showSlide(currentSlide - 1);
      });
    }
    
    if (nextButton) {
      nextButton.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        showSlide(currentSlide + 1);
      });
    }
    
    // Soporte para arrastre en móvil (solo cuando stacked está activo)
    const isMobile = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    const isStacked = carouselWrapper.hasAttribute('data-stacked');
    
    if (isMobile && isStacked) {
      let touchStartX = 0;
      let touchStartY = 0;
      let touchCurrentX = 0;
      let touchCurrentY = 0;
      let isDragging = false;
      let isHorizontalSwipe = false;
      let startTranslate = 0;
      let currentTranslate = 0;
      let animationID = null;
      
      function getPositionX(event) {
        return event.type.includes('mouse') ? event.clientX : event.touches[0].clientX;
      }
      
      function getPositionY(event) {
        return event.type.includes('mouse') ? event.clientY : event.touches[0].clientY;
      }
      
      function setSliderPosition() {
        carouselElement.style.transform = `translateX(${currentTranslate}%)`;
      }
      
      function animation() {
        setSliderPosition();
        if (isDragging) {
          animationID = requestAnimationFrame(animation);
        }
      }
      
      function onStart(event) {
        if (!isMobile && event.type === 'mousedown') return;
        if (!isStacked) return;
        
        const positionX = getPositionX(event);
        const positionY = getPositionY(event);
        touchStartX = positionX;
        touchStartY = positionY;
        isDragging = true;
        isHorizontalSwipe = false;
        startTranslate = -currentSlide * 100;
        currentTranslate = startTranslate;
        carouselElement.style.transition = 'none';
        animationID = requestAnimationFrame(animation);
        
        if (event.type === 'mousedown') {
          event.preventDefault();
        }
      }
      
      function onMove(event) {
        if (!isDragging) return;
        
        const positionX = getPositionX(event);
        const positionY = getPositionY(event);
        touchCurrentX = positionX;
        touchCurrentY = positionY;
        
        const movedX = touchCurrentX - touchStartX;
        const movedY = touchCurrentY - touchStartY;
        const absMovedX = Math.abs(movedX);
        const absMovedY = Math.abs(movedY);
        
        if (!isHorizontalSwipe) {
          if (absMovedX > 3 && (absMovedX > absMovedY || absMovedX > 10)) {
            isHorizontalSwipe = true;
          }
        }
        
        if (isHorizontalSwipe) {
          event.preventDefault();
          event.stopPropagation();
          const carouselWidth = carouselElement.offsetWidth;
          const movedPercent = (movedX / carouselWidth) * 100;
          let newTranslate = startTranslate + movedPercent;
          
          if (currentSlide === 0 && newTranslate > 0) {
            newTranslate = 0;
          }
          
          if (currentSlide === totalSlides - 1 && newTranslate < startTranslate) {
            newTranslate = startTranslate;
          }
          
          currentTranslate = newTranslate;
        }
      }
      
      function onEnd(event) {
        if (!isDragging) return;
        
        isDragging = false;
        if (animationID) {
          cancelAnimationFrame(animationID);
        }
        carouselElement.style.transition = 'transform 0.4s ease-in-out';
        
        if (isHorizontalSwipe) {
          const moved = touchCurrentX - touchStartX;
          const carouselWidth = carouselElement.offsetWidth;
          const threshold = carouselWidth * 0.25;
          
          if (Math.abs(moved) > threshold) {
            if (moved > 0 && currentSlide > 0) {
              showSlide(currentSlide - 1);
            } else if (moved < 0 && currentSlide < totalSlides - 1) {
              showSlide(currentSlide + 1);
            } else {
              showSlide(currentSlide);
            }
          } else {
            showSlide(currentSlide);
          }
        } else {
          showSlide(currentSlide);
        }
        
        isHorizontalSwipe = false;
      }
      
      carouselElement.addEventListener('touchstart', onStart, { passive: false });
      carouselElement.addEventListener('touchmove', onMove, { passive: false });
      carouselElement.addEventListener('touchend', onEnd, { passive: true });
      carouselElement.addEventListener('touchcancel', onEnd, { passive: true });
    }
  }
  
  // Desktop hover behavior for product cards
  function initDesktopHoverBehavior(carouselWrapper, carouselId, totalSlides) {
    // Only run on desktop (screen width > 699px)
    if (window.matchMedia('(max-width: 699px)').matches) {
      return;
    }
    
    // Only proceed if there's more than 1 slide
    if (totalSlides <= 1) {
      return;
    }
    
    const productCardFigure = carouselWrapper.closest('.product-card__figure');
    if (!productCardFigure) return;
    
    const carouselAPI = window['carousel_' + carouselId];
    if (!carouselAPI) return;
    
    let hoverTimeout = null;
    let slideBeforeHover = 0; // Track the slide position before hover
    let wasHovered = false; // Track if hover was triggered
    
    // Function to show second image on hover
    function handleMouseEnter() {
      // Clear any pending timeout
      if (hoverTimeout) {
        clearTimeout(hoverTimeout);
        hoverTimeout = null;
      }
      
      // Save current slide position before hover
      slideBeforeHover = carouselAPI.getCurrentSlide();
      
      // Show second image (index 1) on hover
      if (slideBeforeHover === 0) {
        wasHovered = true;
        carouselAPI.showSlide(1);
      }
    }
    
    // Function to return to first image on mouse leave
    function handleMouseLeave() {
      // Clear any pending timeout
      if (hoverTimeout) {
        clearTimeout(hoverTimeout);
      }
      
      // Return to the first image only if we hovered from the first image
      hoverTimeout = setTimeout(function() {
        const currentSlide = carouselAPI.getCurrentSlide();
        // Only go back to first if we came from first via hover
        if (wasHovered && slideBeforeHover === 0 && currentSlide === 1) {
          carouselAPI.showSlide(0);
        }
        wasHovered = false;
        hoverTimeout = null;
      }, 100); // Small delay to prevent flickering
    }
    
    // Track arrow clicks to respect current position
    const prevButton = carouselWrapper.querySelector('[data-carousel-prev]');
    const nextButton = carouselWrapper.querySelector('[data-carousel-next]');
    
    function handleArrowClick() {
      // When user clicks arrows, update the saved position after slide change
      // Use setTimeout to ensure this runs after the slide change
      setTimeout(function() {
        slideBeforeHover = carouselAPI.getCurrentSlide();
        wasHovered = false; // Reset hover flag since user is manually navigating
      }, 50);
    }
    
    if (prevButton) {
      prevButton.addEventListener('click', handleArrowClick, true);
    }
    
    if (nextButton) {
      nextButton.addEventListener('click', handleArrowClick, true);
    }
    
    // Add hover listeners
    productCardFigure.addEventListener('mouseenter', handleMouseEnter);
    productCardFigure.addEventListener('mouseleave', handleMouseLeave);
  }
  
  function initProductCardCarousels() {
    document.querySelectorAll('[data-product-card-carousel-id]').forEach(function(carouselElement) {
      initProductCardCarousel(carouselElement);
    });
  }
  
  function initCarousels() {
    setTimeout(initProductCardCarousels, 200);
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCarousels);
  } else {
    initCarousels();
  }
  
  const carouselObserver = new MutationObserver(function(mutations) {
    const shouldReinit = mutations.some(function(mutation) {
      return Array.from(mutation.addedNodes).some(function(node) {
        return node.nodeType === 1 && (node.matches?.('[data-product-card-carousel-id]') || node.querySelector?.('[data-product-card-carousel-id]'));
      });
    });
    
    if (shouldReinit) {
      setTimeout(initProductCardCarousels, 100);
    }
  });
  
  carouselObserver.observe(document.body, { childList: true, subtree: true });
})();

// Cart Drawer
function handleCloseDrawer(event) {
  if (event) {
    event.preventDefault();
    event.stopPropagation();
  }
  
  const cartDrawer = document.querySelector('cart-drawer');
  if (!cartDrawer || !cartDrawer.shadowRoot) return;
    const dialogCloseButton = cartDrawer.shadowRoot.querySelector('dialog-close-button');
    if (!dialogCloseButton) return;
    dialogCloseButton.click();
}

// WishlistHero Button Custom Element
(function() {
  let iconObserver = null;
  let customButton = null;
  
  function getOriginalButton() {
    const container = document.querySelector('#wishlisthero-product-page-button-container');
    if (!container) return null;
    return container.querySelector('button');
  }
  
  function createCustomButton() {
    const originalButton = getOriginalButton();
    const atcButtonGroup = document.querySelector('.atc-button-group');
    
    if (!originalButton || !atcButtonGroup) return;
    
    // Remove existing wrapper if it exists
    const existingWrapper = atcButtonGroup.querySelector('[data-wishlist-wrapper]');
    if (existingWrapper) {
      existingWrapper.remove();
    }
    
    // Stop existing observer
    if (iconObserver) {
      iconObserver.disconnect();
      iconObserver = null;
    }
    
    // Create wrapper div
    const wrapper = document.createElement('div');
    wrapper.setAttribute('data-wishlist-wrapper', 'true');
    
    // Clone the entire button with all contents and styles
    customButton = originalButton.cloneNode(true);
    customButton.type = 'button';
    customButton.setAttribute('data-wishlist-custom-button', 'true');
    
    // Transfer click to original button
    customButton.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      originalButton.click();
    });
    
    wrapper.appendChild(customButton);
    atcButtonGroup.appendChild(wrapper);
    
    // Watch for changes to original button and update clone
    iconObserver = new MutationObserver(function() {
      if (customButton && originalButton) {
        customButton.innerHTML = originalButton.innerHTML;
        customButton.style.cssText = originalButton.style.cssText;
      }
    });
    
    iconObserver.observe(originalButton, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style']
    });
  }
  
  function initWishlistCustomButton() {
    // Initial creation
    createCustomButton();
    
    // Listen for variant changes to recreate the button
    document.querySelectorAll('product-form form').forEach(function(form) {
      if (form.dataset.wishlistButtonListener === 'true') return;
      form.dataset.wishlistButtonListener = 'true';
      
      form.addEventListener('variant:change', function() {
        setTimeout(createCustomButton, 150);
      });
      
      form.addEventListener('product:rerender', function() {
        setTimeout(createCustomButton, 150);
      });
    });
  }
  
  function init() {
    setTimeout(initWishlistCustomButton, 500);
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  // Watch for new wishlist button containers being added
  const containerObserver = new MutationObserver(function(mutations) {
    const shouldReinit = mutations.some(function(mutation) {
      return Array.from(mutation.addedNodes).some(function(node) {
        if (node.nodeType === 1 && node.closest?.('.atc-button-group')) {
          return false;
        }
        
        return node.nodeType === 1 && (
          node.id === 'wishlisthero-product-page-button-container' ||
          node.querySelector?.('#wishlisthero-product-page-button-container')
        );
      });
    });
    
    if (shouldReinit) {
      setTimeout(createCustomButton, 200);
    }
  });
  
  containerObserver.observe(document.body, { childList: true, subtree: true });
})();



// announcement bar in viewport
(function() {
  const headerSidebar = document.querySelector("header-sidebar");
  const announcementBar = document.querySelector(".shopify-section--announcement-bar");
  
  if (!headerSidebar || !announcementBar) {
    return;
  }

  const announcementBarObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      headerSidebar.classList.toggle("announcement-bar-in-viewport", entry.isIntersecting);
    });
  }, {
    threshold: 0,
    rootMargin: '0px'
  });

  announcementBarObserver.observe(announcementBar);
  
  
})();